export const removeEmptyParams = (
  params: Record<string, unknown>,
  options?: { exclude?: string[] },
): void => {
  const excluded = new Set(options?.exclude ?? []);

  Object.keys(params).forEach((key) => {
    if (excluded.has(key)) return;

    if (
      params[key] === undefined ||
      params[key] === null ||
      params[key] === ''
    ) {
      delete params[key];
    }
  });
};
